import { useMemo } from "react";
import { BaseballTable } from "../tables/BaseballTable";
import {
  columnsValueBattingTeam,
  columnsValuePitchingTeam,
  columnsSituationalBattingTeam,
  columnsSituationalPitchingTeam,
  columnsSplitsBattingTeam,
  columnsSplitsPitchingTeam,
  columnsBattedBallBattingTeam,
  columnsBattedBallPitchingTeam,
  columnsBaserunningTeam,
} from "../../config/leaderboards";

const stripRank = (cols) => cols.filter((c) => c.name !== "#");
const unlink = (cols) => cols.map((c) => {
  if (c.name === "Team") {
    return { ...c, cell: undefined };
  }
  return c;
});

const COLUMN_MAP = {
  value_batting_team: () => unlink(stripRank(columnsValueBattingTeam)),
  value_pitching_team: () => unlink(stripRank(columnsValuePitchingTeam)),
  situational_batting_team: () => unlink(stripRank(columnsSituationalBattingTeam)),
  situational_pitching_team: () => unlink(stripRank(columnsSituationalPitchingTeam)),
  splits_batting_team: () => unlink(stripRank(columnsSplitsBattingTeam)),
  splits_pitching_team: () => unlink(stripRank(columnsSplitsPitchingTeam)),
  batted_ball_batting_team: () => unlink(stripRank(columnsBattedBallBattingTeam)),
  batted_ball_pitching_team: () => unlink(stripRank(columnsBattedBallPitchingTeam)),
  baserunning_team: () => unlink(stripRank(columnsBaserunningTeam)),
};

export const TeamStatTable = ({ stats, type, teamName }) => {
  const columns = useMemo(() => {
    const getColumns = COLUMN_MAP[type];
    return getColumns ? getColumns() : [];
  }, [type]);

  return (
    <BaseballTable
      data={stats}
      columns={columns}
      filename={`${teamName || "team"}_${type}_stats.csv`}
      noDataComponent={
        <div className="text-center py-12 text-gray-500">
          No leaderboard data available
        </div>
      }
    />
  );
};
